const developmentEnvironment = {
  checkr: {
    baseUrl: ' https://dashboard.checkrhq-staging.net',
  },
  api: {
    baseUrl: `http://localhost:${process.env.REACT_APP_API_BACKEND_PORT || 3001}`,
  },
  pusher: {
    key: '465b70d7691cb62ad395',
  },
  googleapis: {
    apiKey: 'AIzaSyATiMxp0FfFGNHGEX53sjv_WUU4VlkuAY8',
  },
  growthbook: {
    clientKey: 'sdk-z7y8rt9V7D9qd7UN',
    apiHost: 'https://cdn.growthbook.io',
  },
};

export default developmentEnvironment;
